import ChatMessageItemReply from "./chat-message-item-reply";


const ChatMessageType = {
    Reply : ChatMessageItemReply
}

export default ChatMessageType;